import React from "react";

import ProductsTab from "~/pages/SuperAdminDashboard/ProductsTab";

const ProductsDashboard = () => {
  return (
    <div className="space-y-6">
      <ProductsTab />
    </div>
  );
};

export default ProductsDashboard;
